<div class="qr">
  <button
    class="print-btn"
    mat-flat-button
    color="primary"
    (click)="printQRCode()"
  >
    Print QR code
  </button>
  <h1 class="qr-header">Shoutouts for your Favorite Athlete</h1>
  @let event = eventStoreService.event();
  @if (event) {
    <div class="qr-footer">
      <h2 class="qr-footer__event">{{ event.name }}</h2>
      <h3 class="qr-footer__event">{{ event.clientName }}</h3>
    </div>
  }
  <qrcode [qrdata]="shareLink()" [width]="qrWidth" [errorCorrectionLevel]="'M'">
  </qrcode>
  @if (event) {
    <h1 class="qr-footer__price">Price: ${{ lowestPrice() }}</h1>
  }
  <div class="logo">
    <img src="/assets/logo-sm.png" class="logo" alt="logo" />
  </div>
  <a mat-button href="ultimateshoutouts.com" class="branding"
    >ultimateshoutouts.com</a
  >
</div>
